<template>
  <div id="main-wrapper">
    <div v-if="enabled2fa">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-left">
                <p>Google 2FA has been successfully enabled on your web account.</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="enabled2fa = false">OK </a>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="enabled2fa = false">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="disable2fa">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-left">
                <p>Google 2FA has been successfully disabled on your web account.</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="disable2fa = false">OK </a>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="disable2fa = false">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="store.user.profile.gAuthenticatorEnabled"
      class="content-container profile-page e2fa-page"
    >
      <div class="page-wrap">
        <div class="page-content clearfix">
          <Form @submit="disable">
            <div class="main-content f-left">
              <div class="row-sec">
                <div class="title-holder">
                  <h4>
                    Your 2FA authenticator is enabled. Please enter Google
                    Authenticator Code to disable it.
                  </h4>
                </div>
                <div class="form-holder">
                  <ul>
                    <li>
                      <label for=""
                        >Google Authenticator Code<span style="color: #d43737"
                          >*</span
                        ></label
                      >
                      <Field
                        autocomplete="off"
                        name="Google Token"
                        v-model="google_token"
                        rules="required|min:6|max:6|numeric"
                      />
                      <ErrorMessage name="Google Token" />
                    </li>
                  </ul>
                </div>
              </div>
              <div class="btn-holder t-center">
                <button type="submit" class="btn btn-yellow popup-link-holder">
                  Disable
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="store.qrCode" class="content-container profile-page e2fa-page">
        <div class="page-wrap">
          <div class="page-content clearfix">
            <Form @submit="verify">
              <div class="main-content f-left">
                <div class="row-sec">
                  <div class="title-holder t-center">
                    <h4>{{$t("account_security.title")}}</h4>
                  </div>
                  <div class="content-holder t-center">
                    <div class="img-holder">
                      <img src="assets/images/lock-ico.png" alt="" />
                    </div>
                    <p>{{$t("account_security.description")}}</p>
                    <div class="qr-code">
                      <img :src="store.qrCode" alt="" />
                    </div>
                  </div>
                  <div class="form-holder">
                    <ul>
                      <li>
                        <label for="">{{$t("account_security.google_authenticator_code")}}<span style="color: #d43737">*</span></label>
                        <Field
                          autocomplete="off"
                          name="Google Token"
                          v-model="google_token"
                          rules="required|min:6|max:6|numeric"
                        />
                        <ErrorMessage name="Google Token" />
                      </li>
                    </ul>
                    <div class="note">
                      <p><strong>{{$t("account_security.how_to_enable")}}</strong></p>
                      <p>
                        1. {{$t("account_security.download")}} <strong>{{$t("account_security.google_authenticator_app")}}</strong> {{$t("account_security.on_mobile_tablet")}} <br />
                        2. {{$t("account_security.scan_the")}} <strong>{{$t("account_security.qr_code")}}</strong> {{$t("account_security.appearing_above")}}.<br />
                        3. {{$t("account_security.enter_the")}} <strong>{{$t("account_security.passcode")}}</strong> {{$t("account_security.appers_in_google_auth_app")}} <br />
                        4. {{$t("account_security.click_on_the_button")}}<strong>“{{$t("account_security.click_to_enable")}}”</strong
                        >.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="btn-holder t-center">
                  <button
                    type="submit"
                    class="btn btn-yellow popup-link-holder"
                  >
                    {{$t("account_security.click_to_enable")}}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <!-- <div v-else class="content-container profile-page e2fa-page">
        <div class="page-wrap">
          <div class="page-content clearfix">
            <div class="main-content f-left">
              <div class="row-sec">
                <div class="title-holder t-center">
                  <h4>Enable 2 Factor Authentication</h4>
                </div>
                <br /><br />
              </div>
              <div class="btn-holder t-center">
                <button @click="submit" class="btn btn-yellow">
                  Click to Enable
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      google_token: "",
      enabled2fa: false,
      disable2fa : false,
      submitted : false
    };
  },
  components: { Form, Field, ErrorMessage },
  mounted(){
    this.submit()
  },
  methods: {
    submit() {
      this.store.generate2FA({}, true);
    },
    verify() {
      let d = {
        google_token: this.google_token,
      };
      if (this.$route.query.type) {
        if (this.$route.query.type == "leverage") {
          d["redirect"] = "/change-acct-leverage";
        } else if (this.$route.query.type == "ipassword") {
          d["redirect"] = "/reset-investor-pass";
        } else if (this.$route.query.type == "mpassword") {
          d["redirect"] = "/reset-master-pass";
        } else if (this.$route.query.type == "transfer") {
          d["redirect"] = "/internal-transfer";
        } else if (this.$route.query.type == "bonus") {
          d["redirect"] = "/bonus";
        } else if(this.$route.query.type == "withdrawal"){
          d["redirect"] = "/manage-funds";
        } else if(this.$route.query.type == "delete"){
          d["redirect"] = "/manage-account";
        }
        this.store.verify2FA(d, true, this);
      } else {
        this.store.verify2FA(d, true, this);
      }
      // this.google_token = "";
    },
    disable() {
      let d = {
        google_token: this.google_token,
      };
      this.store.disable2FA(d, true,this);
      /*this.google_token = "";*/
    },
  },
};
</script>
